"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveImage = exports.AlternativeInput = exports.CardContent = exports.StyledButton = exports.Input = exports.QuestionTypes = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var react_select_1 = __importDefault(require("react-select"));
var ProgressBar_1 = __importDefault(require("../elements/ProgressBar"));
var Section_1 = __importDefault(require("../elements/Section"));
var Text_1 = __importDefault(require("../elements/Text"));
var Questionnaire_1 = require("../../defaults/Questionnaire");
var _helpers_1 = require("../../helpers");
var max_1 = require("libphonenumber-js/max");
var react_1 = __importStar(require("react"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var react_router_1 = require("react-router");
var styled_components_1 = __importDefault(require("styled-components"));
var contact_1 = require("../../services/contact");
var styled_components_2 = require("../../styled-components");
var Card_1 = __importDefault(require("./Card"));
var DescriptionIcon_1 = __importDefault(require("./DescriptionIcon"));
var QuestionRenderer_1 = __importDefault(require("./QuestionnaireElements/QuestionRenderer"));
var TransitionTiming = 350;
/* Different question types */
var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes[QuestionTypes["noSelection"] = -4] = "noSelection";
    QuestionTypes[QuestionTypes["formSent"] = -3] = "formSent";
    QuestionTypes[QuestionTypes["finish"] = -2] = "finish";
    QuestionTypes[QuestionTypes["loading"] = -1] = "loading";
    QuestionTypes[QuestionTypes["text"] = 0] = "text";
    QuestionTypes[QuestionTypes["select"] = 1] = "select";
    QuestionTypes[QuestionTypes["range"] = 2] = "range";
    QuestionTypes[QuestionTypes["multipleText"] = 3] = "multipleText";
})(QuestionTypes = exports.QuestionTypes || (exports.QuestionTypes = {}));
exports.Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: none;\n  height: unset !important;\n  input[type='radio'] {\n    color: red;\n  }\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    font-size: 12px;\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    font-size: 12px;\n  }\n  :-ms-input-placeholder {\n    /* IE 10+ */\n    font-size: 12px;\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    font-size: 12px;\n  }\n"], ["\n  outline: none;\n  height: unset !important;\n  input[type='radio'] {\n    color: red;\n  }\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    font-size: 12px;\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    font-size: 12px;\n  }\n  :-ms-input-placeholder {\n    /* IE 10+ */\n    font-size: 12px;\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    font-size: 12px;\n  }\n"])));
var genderOptions = [
    { value: 'Frau', label: 'Frau' },
    { value: 'Herr', label: 'Herr' }
];
exports.StyledButton = styled_components_1.default(styled_components_2.ButtonStyled)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 0;\n  display: ", ";\n  align-self: ", ";\n  width: ", ";\n  text-align: center;\n  background-color: ", ";\n  transition: background-color 250ms ease-in-out;\n  border: none;\n  border-radius: ", ";\n  box-shadow: 5px 5px 20px rgb(0 0 0 / 8%);\n  color: #fff !important;\n  font-weight: bold;\n  outline: none;\n  i {\n    vertical-align: middle;\n  }\n  &:hover {\n    cursor: ", ";\n    transform: scale(1.005);\n    box-shadow: 5px 5px 20px rgb(0 0 0 / 16%);\n    transition: box-shadow 0.25s linear, -webkit-box-shadow 0.25s linear;\n  }\n  ", "\n  .subline {\n    text-align: center;\n    font-size: 14px;\n    margin: 0;\n    color: #fff;\n  }\n"], ["\n  margin-bottom: 0;\n  display: ", ";\n  align-self: ", ";\n  width: ", ";\n  text-align: center;\n  background-color: ",
    ";\n  transition: background-color 250ms ease-in-out;\n  border: none;\n  border-radius: ", ";\n  box-shadow: 5px 5px 20px rgb(0 0 0 / 8%);\n  color: #fff !important;\n  font-weight: bold;\n  outline: none;\n  i {\n    vertical-align: middle;\n  }\n  &:hover {\n    cursor: ", ";\n    transform: scale(1.005);\n    box-shadow: 5px 5px 20px rgb(0 0 0 / 16%);\n    transition: box-shadow 0.25s linear, -webkit-box-shadow 0.25s linear;\n  }\n  ",
    "\n  .subline {\n    text-align: center;\n    font-size: 14px;\n    margin: 0;\n    color: #fff;\n  }\n"])), function (_a) {
    var display = _a.display;
    return display || '';
}, function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf || '';
}, function (_a) {
    var width = _a.width;
    return width || '';
}, function (_a) {
    var backgroundColor = _a.backgroundColor, mainColor = _a.mainColor, disabled = _a.disabled;
    return disabled ? 'rgba(19, 1, 1, 0.3)' : backgroundColor || mainColor;
}, function (_a) {
    var border = _a.border;
    return border || '2px';
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var type = _a.type;
    return type === 'finish' &&
        "\n      display: flex;\n      width: 100%;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      font-size: 18px;\n  ";
});
exports.CardContent = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: ", ";\n  background: #fff;\n  padding: ", ";\n  box-shadow: rgb(0 0 0 / 10%) 5px 5px 20px;\n  @media (max-width: ", ") {\n    padding: 0 0 20px;\n    box-shadow: rgb(0 0 0 / 10%) 5px 5px 15px;\n    margin: ", ";\n  }\n\n  .finishCardInnerContainer {\n    padding: 40px;\n    .finishDescription {\n      font-size: 14px;\n    }\n    @media (max-width: ", ") {\n      padding: 0;\n    }\n  }\n"], ["\n  position: ", ";\n  background: #fff;\n  padding: ", ";\n  box-shadow: rgb(0 0 0 / 10%) 5px 5px 20px;\n  @media (max-width: ", ") {\n    padding: 0 0 20px;\n    box-shadow: rgb(0 0 0 / 10%) 5px 5px 15px;\n    margin: ", ";\n  }\n\n  .finishCardInnerContainer {\n    padding: 40px;\n    .finishDescription {\n      font-size: 14px;\n    }\n    @media (max-width: ", ") {\n      padding: 0;\n    }\n  }\n"])), function (_a) {
    var isRelative = _a.isRelative;
    return isRelative && 'relative';
}, function (_a) {
    var padding = _a.padding;
    return padding || '40px 50px';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var margin = _a.margin;
    return margin || '10px 16px';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var CardInner = styled_components_1.default(styled_components_2.DefaultStyled)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-bottom: 0px;\n"], ["\n  padding-bottom: 0px;\n"])));
var AdvantagesContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  padding: 20px 40px 10px;\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  padding: 20px 40px 10px;\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var TitleContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex: 1 1 calc(100% - 50px);\n  justify-content: center;\n  margin: 0 0 10px;\n  @media (min-width: ", ") {\n    padding: 0 60px;\n  }\n  @media (max-width: ", ") {\n    padding: 30px 20px 0;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex: 1 1 calc(100% - 50px);\n  justify-content: center;\n  margin: 0 0 10px;\n  @media (min-width: ", ") {\n    padding: 0 60px;\n  }\n  @media (max-width: ", ") {\n    padding: 30px 20px 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
exports.AlternativeInput = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  label {\n    font-weight: bold;\n    font-size: 14px;\n  }\n  input {\n    border: 1px solid rgb(188, 188, 188);\n    font-size: 16px;\n    padding: 12px 16px;\n    height: 100%;\n    width: 100%;\n    margin: 10px 0 0;\n  }\n"], ["\n  label {\n    font-weight: bold;\n    font-size: 14px;\n  }\n  input {\n    border: 1px solid rgb(188, 188, 188);\n    font-size: 16px;\n    padding: 12px 16px;\n    height: 100%;\n    width: 100%;\n    margin: 10px 0 0;\n  }\n"])));
var ProgressBarContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n"])));
var OuterQuestionsContainer = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: unset;\n  flex: 1;\n  @media (max-width: ", ") {\n    padding: 0;\n    overflow-y: scroll;\n    ::-webkit-scrollbar {\n      display: none;\n    }\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"], ["\n  height: unset;\n  flex: 1;\n  @media (max-width: ", ") {\n    padding: 0;\n    overflow-y: scroll;\n    ::-webkit-scrollbar {\n      display: none;\n    }\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var MiddleQuestionsContainer = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 100%;\n  overflow: hidden;\n  height: ", ";\n  transition: height 250ms ease-in-out;\n"], ["\n  width: 100%;\n  overflow: hidden;\n  height: ", ";\n  transition: height 250ms ease-in-out;\n"])), function (_a) {
    var height = _a.height;
    return height + "px";
});
var QuestionsContainer = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: ", ";\n  transform: ", ";\n  transition: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: ", ";\n  transform: ",
    ";\n  transition: ",
    ";\n"])), function (_a) {
    var length = _a.length;
    return length + "00%";
}, function (_a) {
    var currentIndex = _a.currentIndex, length = _a.length;
    return "translateX(-" + (currentIndex / length) * 100 + "%)";
}, function (_a) {
    var animationDisabled = _a.animationDisabled;
    return animationDisabled ? null : "transform " + TransitionTiming + "ms ease-in-out";
});
var BackButtonContainer = styled_components_1.default(styled_components_2.DefaultStyled)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: none;\n  @media (min-width: ", ") {\n    display: inline-block;\n    position: absolute;\n    left: 0;\n  }\n"], ["\n  display: none;\n  @media (min-width: ", ") {\n    display: inline-block;\n    position: absolute;\n    left: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var BackButton = styled_components_1.default(styled_components_2.ButtonStyled)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  background-color: ", ";\n  border: none;\n  border-radius: 2px;\n  box-shadow: 5px 5px 20px rgb(0 0 0 / 8%);\n  cursor: pointer;\n  outline: none;\n"], ["\n  background-color: ",
    ";\n  border: none;\n  border-radius: 2px;\n  box-shadow: 5px 5px 20px rgb(0 0 0 / 8%);\n  cursor: pointer;\n  outline: none;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor ? backgroundColor : '';
});
var ActionButtonContainer = styled_components_1.default(styled_components_2.DefaultStyled)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: none;\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: ", ";\n    display: flex;\n    button {\n      padding: ", ";\n    }\n    #back-button {\n      margin: 0 10px 0 0;\n    }\n    #next-button {\n      flex: 1 1 0%;\n    }\n  }\n"], ["\n  display: none;\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: ", ";\n    display: flex;\n    button {\n      padding: ", ";\n    }\n    #back-button {\n      margin: 0 10px 0 0;\n    }\n    #next-button {\n      flex: 1 1 0%;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var isFull = _a.isFull;
    return (isFull ? '0' : '0 15px 15px');
}, function (_a) {
    var isFull = _a.isFull;
    return (isFull ? '20px' : '10px');
});
exports.ResponsiveImage = styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  text-align: center;\n  .image-container {\n    width: auto !important;\n    max-width: 100% !important;\n  }\n"], ["\n  text-align: center;\n  .image-container {\n    width: auto !important;\n    max-width: 100% !important;\n  }\n"])));
var questionHistoryStack = [];
var disabledActions = false;
var Questionnaire = function (_a) {
    var _b, _c;
    var _d = _a.initStep, initStep = _d === void 0 ? 1 : _d, initAnswer = _a.initAnswer, mainColor = _a.mainColor, sectionConfig = _a.sectionConfig, cardConfig = _a.cardConfig, navigateAfterFinish = _a.navigateAfterFinish, _e = _a.loadingText, loadingText = _e === void 0 ? 'Bitte warten Sie' : _e, buttons = _a.buttons, questions = _a.questions, advantages = _a.advantages, setShowCloseButton = _a.setShowCloseButton, onFinish = _a.onFinish;
    var history = react_router_1.useHistory();
    /**
     * The Results to each Question
     */
    var _f = react_1.useState(new Map()), resultsMap = _f[0], setResultsMap = _f[1];
    /**
     * Map of the different estimated lengths for each step
     */
    var remainingLengthMap = react_1.useMemo(function () {
        var map = new Map();
        questions.forEach(function (question) {
            var _a, _b;
            var nextStep = question.nextStep || ((_b = (_a = question.answers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.nextStep);
            if (!nextStep) {
                map.set(question.step, 0);
            }
            else {
                var counter = 0;
                var nextQuestion = questions.find(function (q) { return q.step === nextStep; });
                var _loop_1 = function () {
                    var answer = (nextQuestion === null || nextQuestion === void 0 ? void 0 : nextQuestion.answers) && nextQuestion.answers[0];
                    var nextStep_1 = (nextQuestion === null || nextQuestion === void 0 ? void 0 : nextQuestion.nextStep) || (answer === null || answer === void 0 ? void 0 : answer.nextStep);
                    if (!nextStep_1) {
                        map.set(question.step, counter);
                        return "break";
                    }
                    else {
                        nextQuestion = questions.find(function (q) { return q.step === nextStep_1; });
                        counter++;
                    }
                };
                while (true) {
                    var state_1 = _loop_1();
                    if (state_1 === "break")
                        break;
                }
            }
        });
        return map;
    }, [questions]);
    /**
     * Map of the array-index for each step
     */
    var questionStepIndex = react_1.useMemo(function () {
        var map = new Map();
        questions.forEach(function (question, index) {
            map.set(question.step, index);
        });
        return map;
    }, [questions]);
    var mergedButtons = _helpers_1.merge(Questionnaire_1.defaultButtons, buttons);
    var mergedCardConfig = _helpers_1.merge(Questionnaire_1.defaultCardConfig, cardConfig);
    /** CurrentIndex is ONLY FOR THE ANIMATION. DO NOT USE FOR GETTING THE CURRENT QUESTION */
    var _g = react_1.useState(initStep > 1 ? 1 : 0), currentIndex = _g[0], setCurrentIndex = _g[1];
    /** This is the Index in the Questions-Array we are currently using */
    var _h = react_1.useState(initStep - 1 || 0), activeQuestionIndex = _h[0], setActiveQuestionIndex = _h[1];
    var currentQuestion = questions[activeQuestionIndex];
    /**
     * Array of the Filtered Question Indexes
     */
    var _j = react_1.useState([]), filteredQuestions = _j[0], setFilteredQuestions = _j[1];
    /**
     * States
     */
    var _k = react_1.useState({
        gender: 'Frau',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        policy: false
    }), contactData = _k[0], setContactData = _k[1];
    var _l = react_1.useState({
        email: false,
        firstname: false,
        lastname: false,
        phone: false,
        privacy: false
    }), contactErrors = _l[0], setContactErrors = _l[1];
    var _m = react_1.useState(false), sendingForm = _m[0], setSendingForm = _m[1];
    var _o = react_1.useState(275), currentHeight = _o[0], setCurrentHeight = _o[1];
    var _p = react_1.useState(false), animationDisabled = _p[0], setAnimationDisabled = _p[1];
    var _q = react_1.useState(false), nextButtonDisabled = _q[0], setNextButtonDisabled = _q[1];
    /**
     * Refs
     */
    var activeQuestionContainerRef = react_1.useRef(null);
    var activeQuestionConfirmAnswerRef = react_1.useRef(null);
    var isMobile = window.innerWidth <= 767;
    var isTablet = window.innerWidth >= 768 && window.innerWidth <= 1023;
    // Hide Modal close button on loading screen
    react_1.useEffect(function () {
        if (((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === QuestionTypes.loading ||
            (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === QuestionTypes.finish) &&
            setShowCloseButton)
            setShowCloseButton(false);
    }, [currentQuestion]);
    react_1.useLayoutEffect(function () {
        /* Clear history stack */
        questionHistoryStack.splice(0, questionHistoryStack.length);
        questionHistoryStack.push(0);
        // Initialize Answer and Step
        if (initAnswer && initStep) {
            setResultsMap(new Map(resultsMap.set(1, initAnswer)));
            setActiveQuestionIndex(questionStepIndex.get(initStep));
        }
        /* Measure the height every 250 seconds and set the new height,
        this fixes all responsive stuff */
        var interval = setInterval(function () {
            var _a, _b;
            if ((_a = activeQuestionContainerRef === null || activeQuestionContainerRef === void 0 ? void 0 : activeQuestionContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) {
                setCurrentHeight(((_b = activeQuestionContainerRef === null || activeQuestionContainerRef === void 0 ? void 0 : activeQuestionContainerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0);
            }
        }, 150);
        return function () {
            setResultsMap(new Map());
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * The calculated progress
     */
    var progress = react_1.useMemo(function () {
        var _a;
        var remaining = (_a = remainingLengthMap.get(currentQuestion.step)) !== null && _a !== void 0 ? _a : 0;
        var fullLength = resultsMap.size + remaining;
        return ((fullLength - remaining) / fullLength) * 100;
    }, [resultsMap]);
    /**
     * Filter out all Questions that do not have an answer already and were skipped
     */
    react_1.useEffect(function () {
        if (activeQuestionIndex !== null) {
            // We came back to this question but already have a value, clear it
            if (resultsMap.get(currentQuestion.step)) {
                var clonedMap = new Map(resultsMap);
                clonedMap.delete(currentQuestion.step);
                setResultsMap(clonedMap);
            }
            // Filter out all questions that shouldnt be shown
            var filteredQuestions_1 = Array.from(Array(activeQuestionIndex).keys()).filter(function (index) { return !resultsMap.get(questions[index].step); });
            // Set the current Index for our active Questions
            var nextCurrentIndex_1 = questions
                .filter(function (q, index) { return !filteredQuestions_1.some(function (f) { return f === index; }); })
                .findIndex(function (q) { return q.step === currentQuestion.step; }) || 0;
            if (nextCurrentIndex_1 < currentIndex) {
                // We are going backwards, so animate first, then set filtered questions back in
                setCurrentIndex(nextCurrentIndex_1);
                disabledActions = true;
                setTimeout(function () {
                    setAnimationDisabled(true);
                    setFilteredQuestions(filteredQuestions_1);
                    setAnimationDisabled(false);
                    disabledActions = false;
                }, TransitionTiming);
            }
            else {
                // We are going foreward
                // Dont animate around while filtering
                setAnimationDisabled(true);
                setFilteredQuestions(filteredQuestions_1);
                setTimeout(function () {
                    // NextTick so the Hidden Questions are not rendered anymore
                    setAnimationDisabled(false);
                    setCurrentIndex(nextCurrentIndex_1);
                }, 1);
            }
            // Disable the Next Button for Empty Contact Form
            // Questiontype text handles this himself in the Renderer
            if (currentQuestion.type !== QuestionTypes.text &&
                currentQuestion.type !== QuestionTypes.multipleText &&
                currentQuestion.type !== QuestionTypes.select)
                setNextButtonDisabled(currentQuestion.type === QuestionTypes.finish && hasContactError());
            // Send the GTM event
            react_gtm_module_1.default.dataLayer({
                dataLayer: {
                    event: "STEP_" + (currentQuestion.eventName || currentQuestion.step)
                }
            });
        }
    }, [activeQuestionIndex]);
    var goToPreviousStep = function () {
        if (disabledActions)
            return;
        setActiveQuestionIndex(questionHistoryStack.pop() || 0);
    };
    /**
     * Set Answer for the Current Question then go to the next step
     */
    var setAnswerAndGoNext = function (answer, index) {
        var _a, _b, _c, _d;
        if (index === void 0) { index = activeQuestionIndex; }
        if (disabledActions)
            return;
        if (questions[index]) {
            if (currentIndex === 0) {
                setResultsMap(new Map());
            }
            if (answer !== null)
                setResultsMap(new Map(resultsMap.set(questions[index].step, answer)));
            var next = ((_a = questions[index]) === null || _a === void 0 ? void 0 : _a.nextStep) || ((_d = (_c = (_b = questions[index]) === null || _b === void 0 ? void 0 : _b.answers) === null || _c === void 0 ? void 0 : _c.find(function (a) { return a.descriptionConfig.text === answer; })) === null || _d === void 0 ? void 0 : _d.nextStep);
            // We have a next step, go to next step
            if (next) {
                if (!questionHistoryStack.includes(index))
                    questionHistoryStack.push(index);
                setActiveQuestionIndex(questionStepIndex.get(next));
            }
        }
    };
    // # todo
    /* const hasTextInputError = (text: string, textConfig: any) => {
      if (textConfig.minLength && textConfig.minLength > text.length) {
        return true
      } else if (textConfig.maxLength && textConfig.maxLength < text.length) {
        return true
      } else if (textConfig.regex) {
        // If we do not clone we have some weird reference bugs
        const clonedRegex = new RegExp(textConfig.regex)
        return !clonedRegex.test(text)
      }
  
      return false
    } */
    var getSelect = function () {
        return (react_1.default.createElement(react_select_1.default, { name: "gender", placeholder: "Anrede", 
            // @ts-ignore
            onChange: function (option) {
                updateContactData({ gender: option === null || option === void 0 ? void 0 : option.value });
            }, options: genderOptions, styles: {
                placeholder: function (styles) { return (__assign(__assign({}, styles), { fontSize: '12px', color: 'hsl(0, 0%, 50%)' })); },
                control: function (styles, _a) {
                    var isFocused = _a.isFocused;
                    return (__assign(__assign({}, styles), { backgroundColor: 'white', minHeight: '44px', borderRadius: '1px', boxShadow: 'none', borderColor: isFocused ? mainColor : 'rgb(188, 188, 188)', '&:hover': {
                            borderColor: isFocused ? mainColor : 'rgb(188, 188, 188)'
                        } }));
                },
                option: function (provided, _a) {
                    var isSelected = _a.isSelected;
                    return (__assign(__assign({}, provided), { borderRadius: '1px !important', borderColor: 'rgb(188, 188, 188)', backgroundColor: isSelected ? mainColor : 'transparent', color: 'black', '&:hover': {
                            backgroundColor: '#F5F5F5',
                            color: 'black'
                        } }));
                }
            } }));
    };
    var sendForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var gender, firstname, lastname, email, phone, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (hasContactError(true))
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    setSendingForm(true);
                    gender = contactData.gender, firstname = contactData.firstname, lastname = contactData.lastname, email = contactData.email, phone = contactData.phone;
                    return [4 /*yield*/, contact_1.sendQuestionnaireForm({
                            gender: gender,
                            firstname: firstname,
                            lastname: lastname,
                            email: email,
                            phone: phone,
                            questions: Array.from(resultsMap).map(function (_a) {
                                var _b, _c, _d;
                                var step = _a[0], answer = _a[1];
                                return ({
                                    Frage: ((_d = (_c = (_b = questions[questionStepIndex.get(step)]) === null || _b === void 0 ? void 0 : _b.cardConfig) === null || _c === void 0 ? void 0 : _c.titleConfig) === null || _d === void 0 ? void 0 : _d.text) || 'Frage wurde nicht gefunden',
                                    Antwort: answer
                                });
                            })
                        })];
                case 2:
                    _b.sent();
                    if (onFinish) {
                        onFinish();
                    }
                    if (navigateAfterFinish) {
                        history.push(navigateAfterFinish);
                    }
                    else {
                        if (setShowCloseButton)
                            setShowCloseButton(true);
                        if (currentQuestion.nextStep)
                            setActiveQuestionIndex(questionStepIndex.get(currentQuestion.nextStep));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    alert('Es ist ein Fehler aufgetreten');
                    return [3 /*break*/, 5];
                case 4:
                    setSendingForm(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Contact Functions
     */
    var hasContactError = function (set) {
        if (set === void 0) { set = false; }
        var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailError = !contactData.email || !emailRegex.test(contactData.email.toLowerCase());
        var phone = max_1.parsePhoneNumberFromString(contactData.phone, 'DE');
        var phoneError = !contactData.phone ||
            contactData.phone.includes('12345') ||
            !phone ||
            !phone.isValid();
        if (set)
            setContactErrors({
                firstname: !contactData.firstname,
                lastname: !contactData.lastname,
                email: emailError,
                phone: phoneError,
                privacy: !contactData.policy
            });
        return (!contactData.firstname ||
            !contactData.lastname ||
            emailError ||
            phoneError ||
            !contactData.policy);
    };
    var updateContactData = function (property) {
        setContactData(function (c) { return (__assign(__assign({}, c), property)); });
    };
    react_1.useEffect(function () {
        if (currentQuestion.type === QuestionTypes.finish)
            setNextButtonDisabled(hasContactError());
    }, [contactData]);
    return (react_1.default.createElement(Section_1.default, __assign({}, sectionConfig),
        react_1.default.createElement(Card_1.default, __assign({}, mergedCardConfig, { padding: { desktop: '0', mobile: '0', tablet: '0' } }),
            currentQuestion.type !== QuestionTypes.finish &&
                currentQuestion.type !== QuestionTypes.formSent && (react_1.default.createElement(CardInner, { padding: mergedCardConfig === null || mergedCardConfig === void 0 ? void 0 : mergedCardConfig.padding },
                react_1.default.createElement(ProgressBarContainer, null,
                    react_1.default.createElement(ProgressBar_1.default, { bgColorActive: mainColor, bgColor: '#eee', completed: progress })),
                react_1.default.createElement(TitleContainer, null,
                    react_1.default.createElement(react_1.default.Fragment, null,
                        currentQuestion.step > 1 &&
                            currentQuestion.type !== QuestionTypes.loading && (react_1.default.createElement(BackButtonContainer, null,
                            react_1.default.createElement(BackButton, __assign({}, mergedButtons.backButton, { onClick: goToPreviousStep }),
                                react_1.default.createElement("i", { className: "material-icons" }, "navigate_before")))),
                        react_1.default.createElement(Text_1.default, __assign({}, Questionnaire_1.defaultQuestionTitleConfig, (_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.cardConfig) === null || _b === void 0 ? void 0 : _b.titleConfig)))))),
            react_1.default.createElement(OuterQuestionsContainer, null,
                react_1.default.createElement(MiddleQuestionsContainer, { height: currentHeight },
                    react_1.default.createElement(QuestionsContainer, { length: questions.length - filteredQuestions.length, currentIndex: currentIndex, animationDisabled: animationDisabled }, questions.map(function (q, index) { return (react_1.default.createElement(QuestionRenderer_1.default, { hidden: filteredQuestions.includes(index), key: q.step, activeQuestionContainerRef: currentQuestion.step === q.step
                            ? activeQuestionContainerRef
                            : null, activeQuestionConfirmAnswerRef: currentQuestion.step === q.step
                            ? activeQuestionConfirmAnswerRef
                            : null, question: q, mainColor: mainColor, onePerRow: (isMobile && q.asListOnMobile) ||
                            ((isMobile || isTablet) &&
                                q.answers &&
                                q.answers.length === 3) ||
                            (q.answers && q.answers.length >= 5), index: index, mergedCardConfig: mergedCardConfig, mergedButtons: mergedButtons, setDisabledActions: function (v) { return (disabledActions = v); }, loadingText: loadingText, setAnswer: setAnswerAndGoNext, sendForm: sendForm, isActive: currentQuestion.step === q.step, nextButtonDisabled: nextButtonDisabled, contactData: contactData, updateContactData: updateContactData, setNextButtonDisabled: setNextButtonDisabled, contactErrors: contactErrors, sendingForm: sendingForm, getSelect: getSelect, goToPreviousStep: goToPreviousStep })); })))),
            currentQuestion && currentQuestion.step > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ActionButtonContainer, __assign({ isFull: currentQuestion.type === QuestionTypes.finish ||
                        currentQuestion.type === QuestionTypes.formSent }, Questionnaire_1.defaultActionButtonContainer),
                    currentQuestion.type !== QuestionTypes.loading &&
                        currentQuestion.type !== QuestionTypes.finish &&
                        currentQuestion.type !== QuestionTypes.formSent && (react_1.default.createElement(exports.StyledButton, __assign({ id: "back-button" }, mergedButtons.previous, { onClick: goToPreviousStep }),
                        react_1.default.createElement("i", { className: "material-icons" }, "navigate_before"),
                        mergedButtons.previous.text)),
                    currentQuestion.nextStep &&
                        (currentQuestion.type === QuestionTypes.range ||
                            currentQuestion.type === QuestionTypes.text ||
                            currentQuestion.type === QuestionTypes.multipleText ||
                            (currentQuestion.type === QuestionTypes.select && ((_c = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.selectConfig) === null || _c === void 0 ? void 0 : _c.isMultiSelect))) && (react_1.default.createElement(exports.StyledButton, __assign({ mainColor: mainColor }, mergedButtons.next, { disabled: nextButtonDisabled, id: "next-button", onClick: function () {
                            var _a;
                            (_a = activeQuestionConfirmAnswerRef === null || activeQuestionConfirmAnswerRef === void 0 ? void 0 : activeQuestionConfirmAnswerRef.current) === null || _a === void 0 ? void 0 : _a.call(activeQuestionConfirmAnswerRef);
                        } }),
                        mergedButtons.next.text,
                        react_1.default.createElement("i", { className: "material-icons" }, "navigate_next"))),
                    currentQuestion.type === QuestionTypes.finish && (react_1.default.createElement(exports.StyledButton, __assign({ mainColor: mainColor }, mergedButtons.finish, { type: "finish", border: "0px", disabled: nextButtonDisabled || sendingForm, onClick: sendForm }),
                        mergedButtons.finish.text,
                        mergedButtons.finish.subline && (react_1.default.createElement("span", { className: "subline" }, mergedButtons.finish.subline)))))))),
        (advantages === null || advantages === void 0 ? void 0 : advantages.length) && (react_1.default.createElement(AdvantagesContainer, null, advantages.map(function (advantage, index) {
            return (react_1.default.createElement(DescriptionIcon_1.default, { key: "advantage-icon-" + index, descriptionConfig: __assign(__assign({}, Questionnaire_1.defaultAdvantageDescriptionConfig.descriptionConfig), advantage.descriptionConfig), iconConfig: __assign(__assign({}, Questionnaire_1.defaultAdvantageDescriptionConfig.iconConfig), advantage.iconConfig) }));
        })))));
};
exports.default = Questionnaire;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
//# sourceMappingURL=Questionnaire.js.map